import { useEffect, useState, useRef } from "react";
import { ArrowRight, Loader2 } from "lucide-react";

const CALENDLY_URL = "https://calendly.com/bldventuresgroup-marketing/30min";
const CALENDLY_FALLBACK = "https://calendly.com/bldventuresgroup-marketing/30min?hide_gdpr_banner=1";

export default function CallPage() {
  const [failed, setFailed] = useState(false);
  const attempted = useRef(false);

  const openPopup = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    } else {
      window.location.href = CALENDLY_FALLBACK;
    }
  };

  useEffect(() => {
    // Set noindex
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex";
      document.head.appendChild(meta);
    } else {
      meta.content = "noindex";
    }

    if (attempted.current) return;
    attempted.current = true;

    const tryOpen = () => {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({ url: CALENDLY_URL });
      } else {
        setFailed(true);
        window.location.href = CALENDLY_FALLBACK;
      }
    };

    // Wait for Calendly script, retry up to ~4s
    let elapsed = 0;
    const interval = setInterval(() => {
      elapsed += 200;
      if (window.Calendly) {
        clearInterval(interval);
        tryOpen();
      } else if (elapsed >= 4000) {
        clearInterval(interval);
        tryOpen();
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      data-testid="call-page"
      className="min-h-screen bg-[#0e1116] flex flex-col items-center justify-center px-6 text-center"
    >
      <span className="font-['Playfair_Display'] font-semibold text-[20px] text-white/40 tracking-tight mb-10">
        BLD Marketing
      </span>

      {!failed && (
        <Loader2
          className="w-6 h-6 text-[#0064E0] animate-spin mb-8"
          strokeWidth={2}
        />
      )}

      <h1
        data-testid="call-heading"
        className="font-['Playfair_Display'] font-semibold text-[28px] md:text-[36px] text-white tracking-[-0.02em] leading-[1.15]"
      >
        Opening your booking window
      </h1>

      <p className="mt-4 text-[16px] text-white/50 max-w-[380px]">
        If it does not open in a moment, use the button below.
      </p>

      <button
        data-testid="call-cta-button"
        onClick={openPopup}
        className="mt-10 btn-primary calendly-cta inline-flex items-center justify-center gap-3 bg-[#0064E0] text-white rounded-xl px-10 py-[18px] text-[16px] font-medium hover:bg-[#0052CC] focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2 focus:ring-offset-[#0e1116]"
      >
        Book a Discovery Call
        <ArrowRight className="arrow-icon w-[18px] h-[18px]" />
      </button>
    </div>
  );
}
